module.exports = __webpack_public_path__ + "img/usecase3.8d42fbb.svg";